
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video-converter",
      function () {
        return require("private-next-pages/video-converter/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/video-converter"])
      });
    }
  